const normalizeTag = (tag: string): string => tag.trim().toLowerCase();

export function parseResourceListTagList(value: string | null | undefined): string[] {
  if (!value) {
    return [];
  }

  return [...new Set(
    value
      .split(',')
      .map(normalizeTag)
      .filter((tag) => tag.length > 0),
  )];
}

export function resourceListTagFilterHref(projectId: string, tag: string): string {
  const normalizedTag = normalizeTag(tag);
  const params = new URLSearchParams();
  if (normalizedTag) {
    params.set('tags', normalizedTag);
  }
  const query = params.toString();
  return `/projects/${projectId}/resources${query ? `?${query}` : ''}`;
}

export function parseResourceListTagsFromSearchParams(searchParams: URLSearchParams): string[] {
  return parseResourceListTagList(searchParams.get('tags'));
}

export function parseResourceListExcludedTagsFromSearchParams(searchParams: URLSearchParams): string[] {
  return parseResourceListTagList(searchParams.get('excludeTags'));
}
